import { Button, Col, Row } from 'antd'
import { FC } from 'react'

export interface PopoverFooterProps {
    onCancel: () => void
    onSave: () => void
    cancelText?: string
    saveText?: string
}

const PopoverFooter: FC<PopoverFooterProps> = ({
    onCancel,
    onSave,
    cancelText = 'Отмена',
    saveText = 'Сохранить',
}) => (
    <Row gutter={8}>
        <Col span={12}>
            <Button block onClick={onCancel}>
                {cancelText}
            </Button>
        </Col>
        <Col span={12}>
            <Button type='primary' block onClick={onSave}>
                {saveText}
            </Button>
        </Col>
    </Row>
)

export default PopoverFooter
